import './script-editor-page.css';
import { Button, Modal, notification } from "antd";
import { TdiNodeModel } from "../../model/tdi-node-model";
import { useEffect, useState } from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs";
import { useTestTransformerScriptMutation } from '../../redux/api/transformers';

interface Props {
    clientId: number,
    open: boolean,
    node?: TdiNodeModel,
    onCancel: (values: any) => void
}

export const ScriptTestModal: React.FC<Props> = ({clientId, open, onCancel}): JSX.Element => {

    const [source, setSource] = useState<string>('');
    const [output, setOutput] = useState<string>('');
    
    const [testScript] = useTestTransformerScriptMutation();
    
    useEffect(() => {
    }, []);

    const preview = async () => {
        try {
            const response = await testScript({clientId, data: source}).unwrap();
            setOutput(JSON.stringify(response, null, 2));
        } catch (e) {
            setOutput('');
            notification.error({
            message: "Preview Failed!",
            description: `Failed to convert source data into target output.`
            });
        }
    }

    return (<Modal
        title={'Output Preview'}
        closable={true}
        open={open}
        onCancel={onCancel}
        destroyOnClose={true}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={1040}>
        <div className="preview-container">
            <div className="outpreview-container">
                <div className="content-container">
                    <div className="source-container">
                        <label>Source</label>
                        <div className="area-container">
                            <Editor
                                value={source}
                                onValueChange={source => setSource(source)}
                                highlight={(code) => highlight(code, languages.js!, 'js')}
                                padding={10}
                                style={{
                                    minHeight: '25rem',
                                    background: 'white',
                                    border: 'none',
                                    fontFamily: '"Fira code", "Fira Mono", monospace',
                                    fontSize: 14,
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="content-container">
                    <div className="source-container">
                        <label>Output</label>
                        <div className="area-container">
                            <Editor
                                value={output}
                                onValueChange={output => setOutput(output)}
                                highlight={(output) => highlight(output, languages.js!, 'js')}
                                padding={10}
                                style={{
                                    minHeight: '25rem',
                                    background: 'white',
                                    border: 'none',
                                    fontFamily: '"Fira code", "Fira Mono", monospace',
                                    fontSize: 14,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="preview-button-container">
                <Button type="primary" 
                    onClick={preview} 
                    disabled={null == source}>
                    Preview Output
                </Button>
            </div>
        </div>
    </Modal>)
}
